'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorFromXml = getErrorFromXml;

var _utils = require('./utils');

/**
 * @module opensearch/error
 */

/**
 * Try to parse an OWS ExceptionReport and create an Error object from the
 * parsed values.
 * @param {string} xmlStr The XML string to parse the exception from.
 * @returns {Error|null} The parsed error object or null of parsing failed.
 */
function getErrorFromXml(xmlStr) {
  try {
    var root = (0, _utils.parseXml)(xmlStr).documentElement;
    var exceptionElement = (0, _utils.getFirstElement)(root, root.namespaceURI, 'Exception');

    if (!exceptionElement) {
      return null;
    }

    var message = ((0, _utils.getText)(exceptionElement, exceptionElement.namespaceURI, 'ExceptionText') || '').trim();
    var code = exceptionElement.getAttribute('exceptionCode');
    return new Error(message.length ? message : code);
  } catch (error) {
    return null;
  }
}


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/error.js